import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import { strCode } from "../../../consts";
import { t } from "../../../services";

import {
  FlexContainers,
  Modal,
  Notification,
  SmallButton,
  WrapperContainer
} from "../../../components";
import ImportedRecordsTable from "../../../components/BatchCreate/components/ImportedRecordsTable/ImportedRecordsTable";
import {
  ImportingSummaryWrapper,
  TableTitle
} from "../../../components/BatchCreate/components/ImportingSummary/components/styled";

import { DeviceCertificatesColumns } from "./components/DeviceCertificatesColumns";
import { DownloadModalContainer } from "./styled";

const DeviceBatchCertificatesDownload = ({ active, setActive, onDownload, loading, devices }) => {
  const [deviceRows, setDeviceRows] = useState([]);

  useEffect(() => {
    const rows = Array.from(devices).map((value, i) => {
      return { index: i + 1, ...value };
    });

    setDeviceRows(rows);
  }, [devices]);

  return (
    <Modal
      active={active}
      closable={false}
      title={t(strCode.IMPORTING_SUMMARY_TITLE)}
      Container={DownloadModalContainer}
      modalFooter={
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width={"100%"}>
          <SmallButton secondary disabled={loading} onClick={() => setActive(false)}>
            {t(strCode.CLOSE_BTN)}
          </SmallButton>
          <SmallButton
            loading={loading}
            disabled={loading}
            onClick={async () => await onDownload(devices)}>
            {t(strCode.DOWNLOAD_CERTIFICATES)}
          </SmallButton>
        </WrapperContainer>
      }>
      <ImportingSummaryWrapper Container={FlexContainers.FlexColumnStart} width={"100%"} gap={24}>
        <Notification
          id="device-import-success"
          type="success"
          title={t(strCode.RECORDS_UPLOAD_SUCCESS)}
          message={t(strCode.DEVICES_IMPORT_INFO_SUCCESS, {
            correctRecords: devices.length,
            totalLength: devices.length
          })}
        />

        <WrapperContainer Container={FlexContainers.FlexRowBetween} width={"100%"}>
          <TableTitle>{`${t(strCode.CORRECT_RECORDS)} (${devices.length})`}</TableTitle>
        </WrapperContainer>

        <ImportedRecordsTable
          records={deviceRows}
          ImportedRecordsTableColumns={DeviceCertificatesColumns}
        />
      </ImportingSummaryWrapper>
    </Modal>
  );
};

DeviceBatchCertificatesDownload.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  devices: PropTypes.array
};

export default DeviceBatchCertificatesDownload;
